// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-locked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14.499 17H21.499V21.5H14.499V17Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V10M15 6.5V10M9 17.5V3.5M9 17.5L10.5 18.375","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.75 17V15.25C15.75 14.0074 16.7574 13 18 13C19.2426 13 20.25 14.0074 20.25 15.25V17M14.499 17H21.499V21.5H14.499V17Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapLockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-locked',
    ref,
    icon: element,
  },
));

MapLockedIcon.displayName = 'MapLockedIcon';

export default MapLockedIcon;
